import { useEffect, useState } from "react";
import { SkipForward } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { leftToPost, skipForNow } from "@/lib/batchNext";

// Beside the Post button when the item came from a batch: how many are left, and a way to come back to this one later.
export default function BatchLeft({ batchId, draftId, onSkip }) {
  const [left, setLeft] = useState(null);
  useEffect(() => {
    let live = true;
    api.get(`/photo-batches/${batchId}`).then(({ data }) => live && setLeft(leftToPost(data.items).length)).catch(() => {});
    return () => { live = false; };
  }, [batchId, draftId]);
  if (left === null) return null;
  return (
    <>
      <span className="inline-flex h-8 items-center rounded-full bg-slate-100 px-3 text-xs font-semibold text-slate-700" data-testid="batch-left-count">
        <b className="mr-1 font-mono">{left}</b> left in this batch
      </span>
      {left > 1 && (
        <Button size="sm" variant="outline" onClick={() => { skipForNow(batchId, draftId); onSkip(); }}
          className="h-8 rounded-full border-slate-300 bg-white text-slate-700 hover:bg-slate-50" data-testid="batch-skip-for-now">
          <SkipForward className="mr-1 h-3 w-3" /> Skip for now
        </Button>
      )}
    </>
  );
}
